

export const GET_PRODUCTS_SUCCESS = 'getProductSuccess'
export const GET_PRODUCTS_FAIL = 'getProductFail'

export const GET_PRODUCT_DETAILS_REQUEST = 'getProductDetailRequest';
export const GET_PRODUCT_DETAILS_SUCCESS = 'getProductDetailSuccess';
export const GET_PRODUCT_DETAILS_FAIL = 'getProductDetailFail';
export const GET_PRODUCT_DETAILS_RESET = 'getProductDetailReset';
